module.exports = __webpack_public_path__ + "static/img/QB500.6267f3b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/QB500.png
// module id = gVYX
// module chunks = 2